import * as React from 'react'
import { useCallback } from 'react'

import { displayLabelIfExists } from '@app/domain/instrument/instrument.helpers'
import type {
  IProgram,
  IProgramInteraction,
} from '@app/domain/program/program.interface'
import {
  IInteractionStatusId,
  ProgramInteractionTypeId,
} from '@app/domain/program/program.interface'

import {
  InteractionLabel,
  StyledSelectGroup,
  StyledSelectOption,
} from './styled-select-group'

const DEFAULT_ADHOC_INTERACTION_LABEL = 'Ad Hoc Follow-up'
const ADHOC_INTERACTION_GROUP_LABEL = 'Ad Hoc Follow-ups'

export type props = {
  initialInteractionCompletedDate: Date
  program: IProgram
  isDisabled?: boolean
}

export const AdHocInteractionSelectOptionsComponent = ({
  initialInteractionCompletedDate,
  program,
  isDisabled,
}: props) => {
  const adHocInteractionSelect = useCallback(
    (interaction: IProgramInteraction) => {
      const initialInteractionIsCompleted =
        initialInteractionCompletedDate !== undefined
      if (
        interaction.interactionType ===
          ProgramInteractionTypeId.AdHocInteraction &&
        (interaction.status === IInteractionStatusId.Active || isDisabled)
      ) {
        const instruments = interaction.instruments.map(displayLabelIfExists)

        return (
          <StyledSelectOption
            key={interaction.id}
            value={interaction.id}
            description={
              !initialInteractionIsCompleted
                ? 'Disabled pending initial interaction.'
                : instruments.join(', ')
            }
            isDisabled={!initialInteractionIsCompleted}
          >
            <InteractionLabel $strikeThrough={!initialInteractionIsCompleted}>
              {interaction.label?.length > 0
                ? interaction.label
                : DEFAULT_ADHOC_INTERACTION_LABEL}
            </InteractionLabel>
          </StyledSelectOption>
        )
      } else {
        return null
      }
    },
    [initialInteractionCompletedDate, isDisabled],
  )

  return (
    <StyledSelectGroup label={ADHOC_INTERACTION_GROUP_LABEL}>
      {program.interactions[ProgramInteractionTypeId.AdHocInteraction]?.map(
        (interaction) => adHocInteractionSelect(interaction),
      )}
    </StyledSelectGroup>
  )
}
